export default "__VITE_ASSET__Dafg3_cP__"